/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon16Regular = forwardRef('ArrowDim1DiagLeftIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.25 2a.75.75 0 0 0-.75-.75h-4c-.69 0-1.25.56-1.25 1.25v4a.75.75 0 0 0 1.5 0V3.81l9.44 9.44H9.5a.75.75 0 0 0 0 1.5h4c.69 0 1.25-.56 1.25-1.25v-4a.75.75 0 0 0-1.5 0v2.69L3.81 2.75H6.5A.75.75 0 0 0 7.25 2Z" })));
});
